<template>
  <div class="yumui-alert-mask2" v-show="visible">
    <div class="yum-alert amint">
      <div class="yum-header">
        <div class="store-name">{{storeInfo.name}}</div>
        <div class="distance" v-show="!showZiTi && distance>0">配送距离约:{{distance/1000}}公里</div>
      </div>
      <div class="yum-body">
        <div class="line"></div>
        <div class="choose-msg">选择外卖配送方式</div>
        <div class="line"></div>
        <div class="choose">
          <div class="item" @click="showZiTi=false">
            <img src="../../assets/image/okIco.png" v-if="!showZiTi" width="30" >
            <img src="../../assets/image/okIco1.png" v-if="showZiTi" width="30" >外送
            <span>快递小哥送货</span>
          </div>

          <div class="item" @click="showZiTi=true">
            <img src="../../assets/image/okIco.png" v-if="showZiTi" width="30" >
            <img src="../../assets/image/okIco1.png" v-if="!showZiTi" width="30" >自提
            <span>自己去门店取货</span>
          </div>
        </div>
        <div class="line"></div>
        <div v-if="showZiTi">
          <div class="address-msg">
            <div class="first">
              门店地址：{{storeInfo.address}}{{storeInfo.houseNo?(","+storeInfo.houseNo):""}}
            </div>
            <div class="second">
              门店电话：{{storeInfo.tel}}
            </div>
          </div>
          <div class="line"></div>
          <div v-if="storeInfo.openReservation">
          <div class="instant" @click="zitiInstant=true;">
            <img src="../../assets/image/okIco.png" v-if="zitiInstant" width="30" alt="">
            <img src="../../assets/image/okIco1.png" v-if="!zitiInstant" width="30" alt="">
            即时自提
          </div>
          <div class="line"></div>
          <div class="reservation" @click="zitiInstant=false;" >
            <div class="timely" >
              <img src="../../assets/image/okIco.png" v-if="!zitiInstant" width="30">
              <img src="../../assets/image/okIco1.png" v-if="zitiInstant" width="30">
              预约
            </div>
            <div class="color-blue padding-5" @click="showCalendar=true;">[{{dispatchDate.text}}]</div>
            <div class="time">
              <input type="number"
                     v-model="zitiTime.hour"
                     readonly
                     @click="showTimePicker=true;
                     zitiInstant=false;">
              :
              <input type="number"
                     v-model="zitiTime.minute"
                     readonly
                     @click="showTimePicker=true;
                     zitiInstant=false;">
            </div>&nbsp;自提
          </div>
          <div class="line"></div>
          </div>
        </div>
        <div v-if="!showZiTi">
          <div class="address-msg">
            <div class="first">
              收货地址：{{userInfo.address}}{{userInfo.houseNo?(","+userInfo.houseNo):""}}
            </div>
            <div class="second">
              收货人/电话：{{!userInfo.username?"":(userInfo.username+"/")}}{{userInfo.tel}}
            </div>
            <button @click="openUserInfo();">添加/修改</button>
          </div>
          <div class="line"></div>
          <div v-if="storeInfo.openReservation">
          <div class="instant" @click="waisongInstant=true;">
            <img src="../../assets/image/okIco.png" v-if="waisongInstant" width="30" >
            <img src="../../assets/image/okIco1.png" v-if="!waisongInstant" width="30">
            即时送达
          </div>
          <div class="line"></div>
          <div class="reservation">
            <div class="timely" @click="waisongInstant=false;">
              <img src="../../assets/image/okIco.png" v-if="!waisongInstant" width="30">
              <img src="../../assets/image/okIco1.png" v-if="waisongInstant" width="30">
              预约
            </div>
            <div class="color-blue padding-5" @click="showCalendar=true;">[{{dispatchDate.text}}]</div>
            <div class="time">
              <input type="number" v-model="waisongTime.hour" min="0" max="23" readonly @click="showTimePicker=true;waisongInstant=false;">
              :
              <input type="number" v-model="waisongTime.minute" min="0" max="59" readonly @click="showTimePicker=true;waisongInstant=false;">
            </div>
            &nbsp;送达
          </div>
          <div class="line"></div>
          </div>
        </div>
      </div>
      <div class="yum-footer" v-show="!showZiTi && !orderTag">
        <div class="tip">非常抱歉~您的收货地址超出了本店的外送范围<br>请您修改收货地址或到店自提</div>
        <button class="yum-button ok disable">{{bnText}}</button>
      </div>
      <div class="yum-footer" v-show="showZiTi || orderTag">
        <button class="yum-button ok enable" @click="startOrder()">{{bnText}}</button>
      </div>
    </div>

    <van-popup v-model="showUserInfo" position="bottom" style="height:90%" z-index="100">
      <user-info :back-save="afterSaveUserInfo" :user-info-list="userInfoList" :search-city="storeInfo.city"></user-info>
    </van-popup>

    <van-picker v-show="showTimePicker" class="time-picker"
                show-toolbar title="选择时间"
                :columns="hourAndMinute"
                @cancel="showTimePicker=false"
                @confirm="onTimePickerConfirm"/>

    <van-calendar  v-model="showCalendar"
                   :min-date="minDate"
                   :max-date="maxDate"
                   :formatter="calendarFormatter"
                   @confirm="OnDateConfirm"/>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Picker,Popup,Calendar } from 'vant';
  import 'vant/lib/picker/style';
  import 'vant/lib/popup/style';
  import 'vant/lib/calendar/style';

  import http from "../../service/ServiceHttp";
  import utils from "../../service/ServiceUtils";
  import UserInfo from "./userinfo.vue";
  import dialog from "../../service/ServiceDialog"

  Vue.use(Picker).use(Popup).use(Calendar);
 
  export default{
    name:"TakeoutDialog",
    data(){
      return{
        bnText:"开始点菜",
        showZiTi:false,
        orderTag:true,
        showUserInfo:false,
        showTimePicker:false,
        showCalendar:false,
        dispatchDate:{
            text:"今天",
            date:new Date().format("yyyy-MM-dd")
        },
        minDate: new Date(),
        maxDate: new Date((new Date()).valueOf()+2*24 * 60 * 60 * 1000),//最多2天
        hourAndMinute:[{values:[]},{values:[]}],
        distance:0,//配送距离
        storeInfo:{
          tel:"",
          address:"",
          houseNo:'',
          gdLat:"",
          gdLng:"",
          sendDistance:0,
          openReservation:0,
          businessTime:[]
        },
        userInfoList:[],
        userInfo:{
          username:"",
          tel:"",
          address:"",
          gdLat:"",
          gdLng:"",
          houseNo:""
        },
        zitiInstant:true,
        zitiTime:{
            hour:"",
            minute:"",
        },
        waisongInstant:true,
        waisongTime:{
            hour:"",
            minute:"",
        },
        visible: false,
      }
    },
    components:{
        UserInfo,
    },
    methods:{
      //开始点菜
      addDay(date,count){
        return new Date(date.valueOf() + (count*24 * 60 * 60 * 1000));
      },
      startOrder() {
            if (this.showZiTi) {//选择了自提
                if (!this.zitiInstant) {//自提的预约
                    if (!this.zitiTime.hour || !this.zitiTime.minute) {
                        this.showTimePicker = true;
                        return;
                    }
                    let time = this.zitiTime.hour + ":" + this.zitiTime.minute;
                    if(this.storeInfo.businessTime.length > 0 && time> this.storeInfo.businessTime[0].endTime){
                        dialog.showAlert("温馨提示","外送预约时间必须在营业时间内！<br>本店营业时间:"+this.storeInfo.businessTimeText)
                        return;
                    }
                    utils.userTakeoutInfo.deliveryType = 0;//自提
                    utils.userTakeoutInfo.timeType = 1;//预约自提
                    utils.userTakeoutInfo.time = this.dispatchDate.date+" "+ time;
                    utils.userTakeoutInfo.timeText = "预约"+utils.userTakeoutInfo.time+"自提";


                } else {
                    utils.userTakeoutInfo.deliveryType = 0;//自提
                    utils.userTakeoutInfo.timeType = 0;//即时自提
                    utils.userTakeoutInfo.time='';
                    if(!this.storeInfo.openReservation){
                        utils.userTakeoutInfo.timeText = undefined;
                    }else{
                        utils.userTakeoutInfo.timeText = "立即自提";
                    }
                }
            } else {//选择了外送
                if(!this.userInfo.address || this.userInfo.address==''){
                    dialog.showAlert("温馨提示", "请填写配送地址!");
                    return;
                }
                if(!this.userInfo.username || this.userInfo.username==''){
                    dialog.showAlert("温馨提示", "请填写联系人!");
                    return;
                }
                if(!this.userInfo.tel || this.userInfo.tel==''){
                    dialog.showAlert("温馨提示", "请填写联系人电话!");
                    return;
                }


                if (!this.waisongInstant) {//外送的预约
                    if (!this.waisongTime.hour || !this.waisongTime.minute) {
                        this.showTimePicker = true;
                        return;
                    }
                    let time = this.waisongTime.hour + ":" + this.waisongTime.minute;
                    if( this.storeInfo.businessTime.length>0 &&  time> this.storeInfo.businessTime[0].endTime){
                        dialog.showAlert("温馨提示","外送预约时间必须在营业时间内！<br>本店营业时间:"+this.storeInfo.businessTimeText)
                        return;
                    }

                    utils.userTakeoutInfo.deliveryType = 1;//预约外送
                    utils.userTakeoutInfo.timeType = 1;//预约外送
                    utils.userTakeoutInfo.time = this.dispatchDate.date+" "+ time;
                    utils.userTakeoutInfo.timeText = "预约"+utils.userTakeoutInfo.time+"送达";
                    let minDate = new Date((new Date()).valueOf()+ 3 * 60 * 60 * 1000);
                    let strMinDate = minDate.format("yyyy-MM-dd HH:mm");



                    if(utils.userTakeoutInfo.time < strMinDate ){
                       dialog.showAlert("温馨提示", "外送预约时间至少提前3小时!");
                       return;
                    }


                } else {
                    utils.userTakeoutInfo.deliveryType = 1;//预约外送
                    utils.userTakeoutInfo.timeType = 0;//即时外送
                    utils.userTakeoutInfo.time = '';
                    utils.userTakeoutInfo.timeText = "即时送达";
                }
                utils.userTakeoutInfo.address = this.userInfo.address+(this.userInfo.houseNo?(","+this.userInfo.houseNo):"");
                utils.userTakeoutInfo.username = this.userInfo.username;
                utils.userTakeoutInfo.tel = this.userInfo.tel;
                utils.userTakeoutInfo.distance = this.distance;
                utils.userTakeoutInfo.gdLat = this.userInfo.gdLat;
                utils.userTakeoutInfo.gdLng = this.userInfo.gdLng;
            }
            this.visible = false;
        },
      calendarFormatter(day){
          var today = this.minDate;
          var tom = this.addDay(today,+1);
          var dat = this.addDay(today,+2);
          const date = day.date.getDate();
          if(date==today.getDate()){
              day.topInfo = '今天';
          }else if(date == tom.getDate()){
              day.topInfo = '明天';
          }else if(date == dat.getDate()){
              day.topInfo = '后天';
          }
          return day;
      },
      OnDateConfirm(date){
            this.showCalendar = false;
            var today = this.minDate;
            var tom = this.addDay(today,+1);
            var dat = this.addDay(today,+2);
            if(date.getDate()==today.getDate()) {
                this.dispatchDate.text = "今天";
            }else if(date.getDate()==tom.getDate()) {
                this.dispatchDate.text = "明天";
            }else if(date.getDate()==dat.getDate()) {
                this.dispatchDate.text = "后天";
            }
            this.dispatchDate.date = date.format("yyyy-MM-dd");
      },
      //选择时间后确定
      onTimePickerConfirm(v, i) {
            if (this.showZiTi) {
                this.zitiTime.hour = v[0];
                this.zitiTime.minute = v[1];
            } else {
                this.waisongTime.hour = v[0];
                this.waisongTime.minute = v[1];
            }
            this.showTimePicker = false;
      },
      //打开用户信息
      openUserInfo(){
          this.showUserInfo = true;
      },
      //点击选择外送或自提
      clickItem: function (item) {
          this.list.forEach(i => {
              i.isSelect = false;
          });
          this.showZiTi = item.type==1?true:false;
          item.isSelect = true;
      },
      //获取外卖配置
      getTakeoutConfig:function(){
         http.getSellerTakeoutConfig(res=>{
             if(res && res.length>0){
                utils.takeoutConfig = res[0];
                this.storeInfo.city= res[0].city;
                this.storeInfo.name = res[0].name;
                this.storeInfo.address = res[0].address;
                this.storeInfo.houseNo = res[0].houseNo;
                this.storeInfo.tel = res[0].telephone;
                this.storeInfo.gdLat = res[0].gdlat;
                this.storeInfo.gdLng = res[0].gdlng;
                this.storeInfo.sendDistance = res[0].sendDistance;
                this.getUserInfo();
             }
         })
      },
      //获取用户信息设置
      getUserInfo() {
            http.getUserTakeoutInfo(list => {
                if (!list || list.length <= 0) return;
                this.userInfoList = list;
                this.userInfo.tel = list[0].tel;
                this.userInfo.username = list[0].contact;
                this.userInfo.address = list[0].location;
                this.userInfo.houseNo = list[0].address;
                this.userInfo.gdLat = list[0].gdLat;
                this.userInfo.gdLng = list[0].gdLng;
                this.calculateDistance();
            });
      },
      calculateDistance() {
            let storeLatLng = {
                lng: this.storeInfo.gdLng,
                lat: this.storeInfo.gdLat,
            };
            let userLatLng = {
                lng: this.userInfo.gdLng,
                lat: this.userInfo.gdLat
            };
            if(!storeLatLng.lat || !storeLatLng.lng || !userLatLng.lat || !userLatLng.lng){
                this.distance = 0;
                return;
            }
            http.calculateDistanceByGdMap(storeLatLng, userLatLng, (d) => {
                this.distance = d;
                if(this.storeInfo.sendDistance>0 && this.distance>this.storeInfo.sendDistance){
                    this.orderTag = false;
                }else{
                    this.orderTag = true;
                }
                utils.takeoutConfig.distance = this.distance;
                http.calculateDeliveryCharge(this.distance,(charge)=>{
                    utils.takeoutConfig.distributionCharge = charge;
                })
            })
      },
      //点击保存用户配送信息后
      afterSaveUserInfo(userInfo){
        this.showUserInfo = false;
        this.userInfo.username = userInfo.username;
        this.userInfo.address = userInfo.address;
        this.userInfo.houseNo = userInfo.houseNo;
        this.userInfo.tel = userInfo.tel;
        this.userInfo.gdLat = userInfo.gdLat;
        this.userInfo.gdLng = userInfo.gdLng;
        this.calculateDistance();
      } ,
      //时间控件初始化
      initTimePicker(){
          this.hourAndMinute[0].values.length=0;
          this.hourAndMinute[1].values.length=0;
          let h = this.minDate.getHours();
          for(var i=0;i<24;++i){
              if(i<10) {
                  this.hourAndMinute[0].values.push("0"+i);
              }else{
                  this.hourAndMinute[0].values.push(""+i);
              }

          }
          this.hourAndMinute[0].defaultIndex = h;
          for(var i=0;i<60;i=i+10){
              if(i<10){
                  this.hourAndMinute[1].values.push("0"+i);
              }else{
                  this.hourAndMinute[1].values.push(""+i);
              }
          }
      }
    },
    mounted(){
        this.initTimePicker();
        this.getUserInfo();
    }

  }
</script>

<style lang="scss" scoped >
  .amint{animation: bounce-in .2s;}
  @keyframes bounce-in {
    0% {transform: scale(0);}
    100% {transform: scale(1);}
  }

  .yumui-alert-mask2 {
    min-height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index:999;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: rgba(0,0,0,.3);
  }
  .yumui-alert-mask2>.yum-alert{
    border-radius: 10px;
    background-color: #fff;
    width: 94%;
    font-size: 16px;
  }
  .yumui-alert-mask2>.yum-alert>.yum-header{
    text-align: center;
    margin-bottom: 0;
    box-shadow: none;
    border-radius: 0;
    color: #333;
    padding:10px;
    .store-name{
      font-weight: 700;
    }
    .distance{
      font-size: 0.8rem;
      color: #B89D76;
    }
  }
  .yumui-alert-mask2>.yum-alert>.yum-body{
    min-height: 36px;
    text-align: center;
    .line{
      /*background-image: url('../../assets/image/fengeLine.svg');*/
      /*background-size: 15px;*/
      /*background-repeat: repeat-x;*/
      /*background-position: 0 100%;*/
      /*height: 8px;*/
      /*width: 100%;*/
      height: 1px;
      width: 100%;
      background: #F9F2E4;
    }
    .choose-msg{
      padding: 10px;
      background-color: #F9F2E4;
      box-shadow: none;
      color: #B89D76;
      margin-top: -2px;
      margin-bottom: -2px;
      z-index: 100;
    }
    .choose{
      padding: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: none;
      .item{
        flex: 1;
        align-self: center;
        img{
          vertical-align: middle;
        }
        span{
          font-size: 0.7rem;
          color: #FF0000;
        }
      }
    }
    .address-msg {
      padding: 8px 12px;
      box-shadow: none;
      text-align: left;
      position: relative;
      .first {
        font-size: 0.9rem;
      }
      .second {
        color: #636363;
        font-size: 0.8rem;
      }
      button {
        position: absolute;
        bottom: 4px;
        right: 5px;
        display: inline-block;
        padding: 4px 4px;
        border-radius: 4px;
        border: none;
        background-color: #BF9E61;
        color: white;
        font-size: 0.8rem;
      }
    }
    .instant{
      padding: 10px;
      display: flex;
      justify-content: left;
      align-items: center;
      box-shadow: none;
      img{
        vertical-align: middle;
        margin: 0 15px 0 0;
      }
    }
    .reservation{
      display: flex;
      justify-content: left;
      align-items: center;
      align-items: center;
      box-shadow: none;
      padding: 10px;
      .timely{
        display: flex;
        align-items: center;
        justify-content: left;
        img{
          vertical-align: middle;
          margin: 0 15px 0 0;
        }
      }
      .time{
        input{
          border: 1px solid #EEE3CD;
          background-color: #F9F2E4;
          border-radius: 5px;
          text-align: center;
          width: 40px;
          height: 25px;
          color: #FF0000;
        }
      }
    }

  }

  .yumui-alert-mask2 > .yum-alert > .yum-footer {
    padding: 10px;
    text-align: center;
    .tip{
      color: #FF0000;
      font-size: 0.9rem;
      margin-bottom: 5px;
    }
    .yum-button.ok {
      color: #fff;
      width: 100%;
      margin: auto;
      padding: 12px;
      border: none;
      border-radius: 5px;
    }
    .yum-button.enable{
      background-color: #BF9E61;
    }
    .yum-button.disable{
      background-color: #CFCFCF;
    }
  }

  .time-picker{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/takeoutDialog/takeoutDialog.vue